import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { ImageRefDto } from '../../shared/models/marketing.models';

@Component({
  selector: 'app-marketing-blog-guide-download',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (guide?.cdnUrl) {
      <aside class="cg-blog-guide">
        <div class="cg-blog-guide__inner">
          <h2 class="cg-blog-guide__title">{{ title }}</h2>
          <p class="cg-blog-guide__lede">{{ subtitle }}</p>
          <a
            class="cg-mkt-btn cg-mkt-btn--primary"
            [href]="guide!.cdnUrl"
            [download]="guide!.fileName || true"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download Guide
          </a>
        </div>
      </aside>
    }
  `,
})
export class MarketingBlogGuideDownloadComponent {
  @Input() guide?: ImageRefDto & { fileName?: string };
  @Input() title = 'Free Downloadable Guide';
  @Input() subtitle = 'Take this checklist with you as you plan your study abroad journey.';
}
